import { t } from "@lingui/macro";
import { useLingui } from "@lingui/react";
import { Helmet } from "react-helmet-async";

import { ContributorsSection } from "./sections/contributors";
import { FAQSection } from "./sections/faq";
import { FeaturesSection } from "./sections/features";
import { HeroSection } from "./sections/hero";
import { LogoCloudSection } from "./sections/logo-cloud";
import { StatisticsSection } from "./sections/statistics";
import { SupportSection } from "./sections/support";
import { TemplatesSection } from "./sections/templates";
import { TestimonialsSection } from "./sections/testimonials";

export const HomePage = () => {
  const { i18n } = useLingui();

  return (
    <main className="relative isolate bg-background">
      <Helmet prioritizeSeoTags>
        <html lang={i18n.locale} />

        <title>
         Coach Lms Resume - Learn. Grow. Succeed
        </title>

        <meta
          name="description"
          content="Learn from 200+ CXOs &amp; MDs, build your own start-up &amp; work with real-world businesses at Masters’ Union PGP &amp; UG Programmes in Tech &amp; Business Management"
        />
      </Helmet>

      <HeroSection />
      {/* <LogoCloudSection /> */}
      {/* <StatisticsSection /> */}
      {/* <FeaturesSection /> */}
      {/* <TemplatesSection /> */}
      {/* <TestimonialsSection /> */}
      {/* <SupportSection /> */}
      {/* <FAQSection /> */}
      {/* <ContributorsSection /> */}
    </main>
  );
};
